export const BASE_URL_CRIAR = 'https://criar.arvore.com.br'
export const CRIAR_CLIENT_ID = 'QHFYIJDJQMAWQVDU'
